import React from 'react';
import { useBookAudioPlayer } from '../../context/bookAudioPlayerContext';

const SpeedSelector = ({ setShowPlaybackMenu, setShowVoiceSettings }) => {
  const { playbackSpeed, handlePlaybackSpeedChange } = useBookAudioPlayer();

  const speeds = ['0.5x', '0.75x', '1x', '1.25x', '1.5x', '1.75x', '2x'];

  const handleSelectSpeed = (speed) => {
    handlePlaybackSpeedChange(speed);
    setShowPlaybackMenu(false);
  };

  const currentSpeedString = `${playbackSpeed}x`;

  return (
    <div
      className="speed-selector"
      onMouseLeave={() => {
        setShowPlaybackMenu(false);
        setShowVoiceSettings(false);
      }}
    >
      <div
        className="tablet-only"
        onClick={() => {
          setShowPlaybackMenu(false);
          setShowVoiceSettings(true);
        }}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.12891 10.2583L3.87012 5.99951L8.12891 1.74072"
            stroke="#FECB04"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Playback Rate
      </div>
      {speeds.map((speed) => (
        <div
          key={speed}
          className={`speed-option ${currentSpeedString === speed ? 'selected' : ''}`}
          onClick={() => handleSelectSpeed(speed)}
        >
          {currentSpeedString === speed && (
            <svg className="checkmark" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M13.3337 4L6.00033 11.3333L2.66699 8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          <span className="speed-text">{speed}</span>
        </div>
      ))}
    </div>
  );
};

export default SpeedSelector;
